module.exports = __webpack_public_path__ + "img/Berriro-Logo.76f2b27b.png";